/**
 *
 *
 * @author Matt Asmar <github.com/MattXXV>
 */

(function ($) {
  'use strict';

  let $slider;

  Drupal.behaviors.initializeRelatedProductSlider = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  function initialize() {
    $slider = $('.related-product-list .slider');

    if (!$slider.length) return false;

    $slider.slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 300,
      variableWidth: true,
      prevArrow: $('.related-product-list .left-arrow'),
      nextArrow: $('.related-product-list .right-arrow'),
      responsive: [
        {
          breakpoint: 1700,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1430,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1145,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 870,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
})(jQuery);
